import { MENU_HIERARCHY, STANDALONE_MODULES } from '@/shared/constants/menuStructure.ts'
import type { MenuItem, MenuGroup } from '@/shared/constants/menuStructure.ts'
import type {PermissionsModule} from "@/services/interfaces/administration/UserAuth.ts";

export function buildMenuFromApi(apiModules: PermissionsModule[] | undefined): (MenuItem | MenuGroup)[] {
    if (!apiModules) return []

    const grouped: Record<string, MenuGroup> = {}
    const flatModules: Record<string, MenuItem> = {}

    apiModules.forEach((module: PermissionsModule) => {
        const moduleName = module.DESCRIPCION_M.toUpperCase()
        let added = false

        // Buscar en la jerarquía configurada
        for (const [group, config] of Object.entries(MENU_HIERARCHY)) {
            if (config.includes.includes(moduleName)) {
                if (!grouped[group]) {
                    grouped[group] = { ...config, children: [] }
                }

                grouped[group].children.push({
                    id: module.ID_MODULO,
                    label: module.NOMBRE_M,
                    icon: STANDALONE_MODULES[moduleName as keyof typeof STANDALONE_MODULES]?.icon || 'fa-solid fa-cube',
                    route: STANDALONE_MODULES[moduleName as keyof typeof STANDALONE_MODULES]?.route || '#',
                    children: null
                })
                added = true
                break
            }
        }

        // Si no pertenece a ningún grupo
        if (!added && STANDALONE_MODULES[moduleName as keyof typeof STANDALONE_MODULES]?.route) {
            flatModules[moduleName] = {
                id: module.ID_MODULO,
                label: module.NOMBRE_M,
                icon: STANDALONE_MODULES[moduleName as keyof typeof STANDALONE_MODULES]?.icon || 'fa-solid fa-cube',
                route: STANDALONE_MODULES[moduleName as keyof typeof STANDALONE_MODULES]?.route || '#',
                children: null
            }
        }
    })

    return [
        ...Object.values(grouped),
        ...Object.values(flatModules)
    ].sort((a, b) => a.id - b.id)
}